<template>
  <v-menu attach :nudge-left=vMenuWidth offset-y :close-on-content-click="false" :min-width="240" transition="scale-transition" v-model="isMenuOpen" ref="vMenu">
    <v-btn id="desktop_account_menu"
           icon
           type="button"
           :label="$t('user_dropdown_menu')"
           :aria-label="$t('user_dropdown_menu')"
           slot="activator"
           @click="calcvMenuWidth()">
      <v-icon class="primary-text">mdi-account</v-icon>
    </v-btn>
    <v-list id="desktop_account_menu_list" class="pt-3 pb-0">
      <v-list-tile avatar class="mt-1">
        <v-list-tile-content>
          <v-layout row align-content-space-between justify-space-between style="width: 100%">
            <v-icon class="pr-2">mdi-message-text</v-icon>
            <v-select class="select-header-menu"
                      :items="getLanguageDescriptions"
                      :label="$t('language_select_label')"
                      :value="getCurrentLanguageDescription"
                      @change="languageChanged"
                      attach
                      content-class="desktop-account-languages"/>
          </v-layout>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="loggedIn && isAdmin"></v-divider>
      <v-subheader v-if="loggedIn && isAdmin" class="text--lighten-4">{{$t('admin.area')}}</v-subheader>
      <v-list-tile v-if="loggedIn && isAdmin && flagEnableAlerts" @click="navigateToAlertsSettings">
        <v-list-tile-content>
          <v-list-tile-title>
            <v-icon class="pr-2">alarm</v-icon>
            {{$t('admin.alerts.alerts')}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="loggedIn && isAdmin" @click="navigateToAnnouncementsSettings">
        <v-list-tile-content>
          <v-list-tile-title>
            <v-icon class="pr-2">announcement</v-icon>
            {{$t('admin.announcements')}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="loggedIn && isAdmin && flagEnableStudentDataPurge" @click="navigateToDataPurge" class="mb-2">
        <v-list-tile-content>
          <v-list-tile-title>
            <i class="icon pr-2">
              <IconManager name="data-purge" height="24" width="24" />
            </i>
            {{$t('admin.data_purge')}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="loggedIn && isAdmin"></v-divider>
      <v-list-tile id="dark_theme">
        <v-switch
          id="accessible-theme"
          :label="$t('dark_theme')"
          :aria-label="$t('aria_label_theme_toggle')"
          hide-details
          v-model="darkTheme"
          :aria-checked="darkTheme ? 'true' : 'false'"
          role="switch" />
      </v-list-tile>
      <template v-if="loggedIn">
        <v-divider></v-divider>
        <v-list-tile id="desktop_account_logout" @click="logout">
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class="pr-2">mdi-logout</v-icon>
              {{$t('logout')}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { LOGOUT } from '../../store/action-types'
  import { HAS_FEATURE_FLAG, IS_ADMIN } from '../../store/getter-types'
  import { SET_ANNOUNCEMENTS, SET_PROFILE_DARK_THEME, SET_PERSONAL_MENU } from '../../store/mutation-types'
  import IconManager from '../misc/IconManager'
  import {LocalizationUtils} from '../../utils/localization-utils'

  export default {
    name: 'personal-menu',
    components: {IconManager},
    data () {
      return {
        vMenuWidth: 205
      }
    },
    methods: {
      logout () {
        this.$store.commit(SET_PERSONAL_MENU, false)
        this.$store.commit(SET_ANNOUNCEMENTS, [])
        this.doLogout()
        if (!this.$store.state.config.useSSO && !this.$store.state.config.useSAML) {
          this.$router.push({name: 'Login'})
        } else {
          window.location.replace(this.$store.state.config.authUrlLogOut)
        }
      },
      languageChanged (description) {
        this.$store.commit(SET_PERSONAL_MENU, false)
        const locale = this.getFromDesc(description)
        this.$i18n.set(locale)

        // patched-vuetify listens this even to do its own job to update the language of error messages.
        const event = new CustomEvent('localeChange')
        document.dispatchEvent(event)

        const utils = new LocalizationUtils()
        utils.setPreferredLanguage(locale)
      },
      ...mapActions({
        'setLanguageFromDescription': 'setLanguageFromDescription',
        doLogout: LOGOUT
      }),
      navigateToAlertsSettings () {
        this.$router.push('/admin/alerts')
        this.$store.commit(SET_PERSONAL_MENU, false)
      },
      navigateToAnnouncementsSettings () {
        this.$router.push('/admin/announcements')
        this.$store.commit(SET_PERSONAL_MENU, false)
      },
      navigateToDataPurge () {
        this.$router.push('/admin/data-purge')
        this.$store.commit(SET_PERSONAL_MENU, false)
      },
      calcvMenuWidth () {
        if (this.$refs.vMenu.dimensions.content.width < 240) {
          this.vMenuWidth = 205
        } else { this.vMenuWidth = this.$refs.vMenu.dimensions.content.width - 35 }
      }
    },
    computed: {
      ...mapState({
        moduleAlert: state => state.profile.module.alert,
        functionAdminMenu: state => state.profile.functions.adminMenu,
        optionEnableAlerts: state => state.profile.options.enable.alerts,
        moduleStudentDataPurge: state => state.profile.module.sdpurge,
        functionStudentDataPurge: state => state.profile.functions.sdpurgeMenu,
        optionStudentDataPurge: state => state.profile.options.enable.sdpMenu
      }),
      ...mapGetters([
        'getCurrentLanguageDescription',
        'getLanguageDescriptions'
      ]),
      ...mapGetters({
        isAdmin: IS_ADMIN,
        getFromDesc: 'getLanguageFromDescription',
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      darkTheme: {
        get () {
          return this.$store.state.profile.darkTheme
        },
        set (value) {
          this.$store.commit(SET_PROFILE_DARK_THEME, value)
        }
      },
      isMenuOpen: {
        get () {
          return this.$store.state.profile.isMenuOpen
        },
        set (value) {
          this.$store.commit(SET_PERSONAL_MENU, value)
        }
      },
      loggedIn () {
        return this.$store.state.profile.loggedIn
      },
      flagEnableAlerts () {
        // Alerting/Admin Menu/Enable Alerts
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionAdminMenu + '.' + this.optionEnableAlerts)
      },
      flagEnableStudentDataPurge () {
        return this.hasFeatureFlag(this.moduleStudentDataPurge + '.' + this.functionStudentDataPurge + '.' + this.optionStudentDataPurge)
      }
    }
  }
</script>

<style scoped>
.select-header-menu >>> label {
  max-width: 100%;
}
#desktop_account_menu_list >>> .list__tile__content {
  overflow: visible;
}

.select-header-menu >>> .desktop-account-languages {
  max-height: 135px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/PersonalMenu.vue